import { render, staticRenderFns } from "./SexRatio.vue?vue&type=template&id=72f21bb4&"
import script from "./SexRatio.vue?vue&type=script&lang=js&"
export * from "./SexRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports